interface StateType {
    mainBgc: string;
    catchDuckBgc: string;
    feedBgc: string;
    feeding: string;
    giftBgc: string;
    grabBgc: string;
    notCatchBgc: string;
    numBgc: string;
    bottomFire: string;
    topFire: string;
    guideBgc: string;
    rageCardBgc: string;
    rageRuleContent: string;
    ruleBgc: string;
    giftImg: string;
    badgeBgc: string;
    badgeBottomBgc: string;
    obtainBtn: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBgc: '',
        catchDuckBgc: '',
        feedBgc: '',
        feeding: '',
        giftBgc: '',
        grabBgc: '',
        notCatchBgc: '',
        numBgc: '',
        bottomFire: '',
        topFire: '',
        guideBgc: '',
        rageCardBgc: '',
        rageRuleContent: '',
        ruleBgc: '',
        giftImg: '',
        badgeBgc: '',
        badgeBottomBgc: '',
        obtainBtn: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
